import { setLocalStorageItem, getLocalStorageItem } from '../../../common/utils/localStorageHelpers'

export const searchesCount = (site) => {
  return getLocalStorageItem(`${site}-search-page-views`, 0)
}

export const countSearchFor = (site) => {
  let searchesCount = getLocalStorageItem(`${site}-search-page-views`, 0)
  setLocalStorageItem(`${site}-search-page-views`, searchesCount + 1)
}



// WEBPACK FOOTER //
// ./common/actions/search/trackSiteSearches.js